import { memo } from 'react';
import { settlementStatusMeta } from './status';
import type { SettlementStatus } from './types';

export const SettlementStatusBadge = memo(function SettlementStatusBadge({ status }: { status: SettlementStatus }) {
  const m = settlementStatusMeta(status);
  return (
    <span className={`inline-flex rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${m.bg} ${m.text} ${m.darkBg} ${m.darkText}`}>
      {m.label}
    </span>
  );
});
